import React, { Fragment, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import FileSaver from "file-saver";
import IconButton from "@material-ui/core/IconButton";
import moment from "moment";
import Tooltip from "@material-ui/core/Tooltip";
import PrintIcon from "@material-ui/icons/Print";
import Typography from "@material-ui/core/Typography";
import { aisDetailFormStyle } from "../../../styles/jss/components/AIS/aisDetailFormStyle";
import AisCategory from "./aisSection/aisCategory";
import LockScreenLoading from "../../LockScreenLoading/LockScreenLoading";
import { generatePdf } from "../../../dataSource/pil";
import { getAISDetails } from "../../../dataSource/ais";
const useStyles = makeStyles((theme) => aisDetailFormStyle(theme));
const AIS = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const store = require("store");
  const [lockScreenLoadingOpen, setLockScreenLoadingOpen] = useState(false);
  const [progressTitle, setProgressTitle] = useState("");
  const [aisDetails, setAisDetails] = useState();
  const [updateFlag, setUpdateFlag] = useState(false);
  const fetchAisDetails = async () => {
    const response = await getAISDetails();
    setAisDetails(response.data);
  };
  useEffect(() => {
    const getAis = async () => {
      await fetchAisDetails();
    };
    getAis();
  }, [updateFlag]);

  const generateAISPdf = async () => {
    setLockScreenLoadingOpen(true);
    const divToDisplay = document.getElementById("test");
    let htmlStr = ` <html>
    <head>
        <meta charset="utf-8">
        <style>
        @page { margin: 1cm;}     
        @media print{
         
        } 
        
    </style>
    </head>
    <body>
    <div style="font-size: 9px;margin:0;">     
    ${divToDisplay.innerHTML}
      </div>    
    </body>
</html>`;
    const pdf = await generatePdf(htmlStr, "");
    FileSaver.saveAs(pdf, `Action Items - ${store.get("site_code")}.pdf`);
    setLockScreenLoadingOpen(false);
  };

  return (
    <Fragment>
      <LockScreenLoading
        open={lockScreenLoadingOpen}
        circleSize={200}
        progressTitle={progressTitle}
      />
      <div id="test">
        <Box>
          <AppBar position="static" color="transparent">
            <Toolbar>
              <Typography variant="h6" className={classes.appbarTest}>
                Action Items
              </Typography>
            </Toolbar>
          </AppBar>
        </Box>
        <Tooltip title="Print PDF">
          <IconButton
            aria-label="add"
            onClick={() => {
              generateAISPdf();
            }}
          >
            <PrintIcon />
          </IconButton>
        </Tooltip>

        {aisDetails &&
          aisDetails.map((obj, index) => {
            return (
              <Grid container spacing={1} key={index}>
                <AisCategory
                  obj={obj}
                  updateFlag={updateFlag}
                  setUpdateFlag={setUpdateFlag}
                />
              </Grid>
            );
          })}
      </div>
    </Fragment>
  );
};

export default AIS;
